const TokenKey = 'TokenKey';
const signCode = 'signCode';
const appToken = 'appToken';
const appClientCode = 'appClientCode';

export function getToken() {
    return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
    return sessionStorage.setItem(TokenKey, `Bearer ${token}`);
}

export function removeToken() {
    return localStorage.removeItem(TokenKey);
}
export function getSign() {
    return localStorage.getItem(signCode);
}

export function getAppToken() {
    return sessionStorage.getItem(appToken);
}

export function getAppClientCode() {
    return sessionStorage.getItem(appClientCode);
}

export function setAppToken(token) {
    return sessionStorage.setItem(appToken, token);
}

export function setAppClientCode(token) {
    return sessionStorage.setItem(appClientCode, token);
}
